import { render, staticRenderFns } from "./Sustainable.vue?vue&type=template&id=28b9f689&scoped=true&"
import script from "./Sustainable.vue?vue&type=script&lang=js&"
export * from "./Sustainable.vue?vue&type=script&lang=js&"
import style0 from "./Sustainable.vue?vue&type=style&index=0&id=28b9f689&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28b9f689",
  null
  
)

export default component.exports